import axios from "axios";

import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

import { reducerGetRoutes, reducerGetRoutesFilters } from "../../reducer/projects/reducers/reducerRoutesList"
import { reducerGetVacantRoutes, reducerGetVacantRoutesFilters } from '../../reducer/projects/reducers/reducerVacantRoutesList'

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetRoutes = (limit: any, page: any) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
    const filter = store.projects.routes.routesInputValues;
    const projectCreateVacancy = store.recruiting.createVacancy.vacancyCreateInputValues.projects;
    const project = projectCreateVacancy ? {project: projectCreateVacancy} : store.projects.projects.currentProject;
    const response = await axios.post(`${BASE_URL}/json/projects/routes/list`, { limit, page, ...filter, ...project })
    dispatch(reducerGetRoutes({ data: response.data }));
}

export const actionGetVacantRoutes = (limit: any, page: any) => async (dispatch: AppDispatch, getState: () => any) => {
    dispatch(reducerGetVacantRoutes({ data: [] }));
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
    const filter = {
        ...store.projects.vacantRoutes.vacantRoutesInputValues,
        projects: store.projects.vacantRoutes.vacantRoutesInputValues.project,
      };
    const response = await axios.post(`${BASE_URL}/json/projects/routes/list`, { limit, page, ...filter })
    dispatch(reducerGetVacantRoutes({ data: response.data }));
}

export const actionGetRoutesFilters = (data: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const response = await axios.post(`${BASE_URL}/json/projects/routes/list/filters`, data)
    dispatch(reducerGetRoutesFilters({ data: response.data }));
    dispatch(reducerGetVacantRoutesFilters({ data: response.data }));
}
